import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '@app/services/navigation/navigation.service';
import { AppStore } from '@app/stores/app/app.store';

@Component({
    selector: 'app-error',
    imports: [MatIconModule, MatButtonModule],
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
    private appStore = inject(AppStore);
    translate = this.appStore.i18n;
    private navigationService = inject(NavigationService);
    private route = inject(ActivatedRoute);

    readonly statusCode = Number(this.route.snapshot.paramMap.get('id'));

    onRetryClicked(e: Event) {
        e.preventDefault();
        this.navigationService.goToHomePage();
    }
}
